import { Asset } from '@/api/generatedApi';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';

export const useGetAssetTenantDisplayName = () => {
  const { data: currentUser } = useGetCurrentUser();

  return {
    getAssetTenantDisplayName: (asset: Asset) =>
      currentUser?.user.settings.find(setting => setting.tenantId === asset?.tenantId)?.tenantDisplayName ?? '',
  };
};
